export default __webpack_public_path__ + "static/media/home1.c2bd4c57.jpg";